module.exports = __webpack_public_path__ + "static/AccessAPI-0eca12c7d2398fd2bc7dfa0e95de237b.png";